module.exports = __webpack_public_path__ + "img/Logo.26db1834.gif";